import { Modal } from "@js/components/modal";

import style from "./style.module.scss";

const REVIEW_MODAL_ID = "review-modal";

export const WriteReviewModalInstance = Modal(REVIEW_MODAL_ID, {
  padding: false,
  className: style.reviewModal,
  keepOnBackdropClick: true,
  closeButtonProps: {
    style: { color: "var(--white)" },
  },
});

export const openWriteReviewModal = () => WriteReviewModalInstance.open();
export const closeWriteReviewModal = () => WriteReviewModalInstance.close();
